// extracted by mini-css-extract-plugin
export var Contact = "index-module--Contact--ytyzu";
export var Contact_container = "index-module--Contact_container--0CV7s";
export var Contact_container_button = "index-module--Contact_container_button--N9e-8";
export var FAQ = "index-module--FAQ--bvnh3";
export var FAQ_body_class = "index-module--FAQ_body_class--a7Fp5";
export var FAQ_body_class_item = "index-module--FAQ_body_class_item--MjyCL";
export var FAQ_body_class_item_qa = "index-module--FAQ_body_class_item_qa--t0L35";
export var FAQ_body_class_item_qa_selected = "index-module--FAQ_body_class_item_qa_selected--VGxw4";
export var FAQ_header = "index-module--FAQ_header--KZ3Bu";
export var FeatureItem = "index-module--FeatureItem--RT5uW";
export var FeatureItem_body = "index-module--FeatureItem_body--XOZDZ";
export var FeatureItem_header = "index-module--FeatureItem_header--t2Ej7";
export var IntroductionItem = "index-module--IntroductionItem--7K9yW";
export var NavBar = "index-module--NavBar--kXJcx";
export var NavBarContainer = "index-module--NavBarContainer--+8ZIY";
export var ProductAdvantage = "index-module--ProductAdvantage--JIvgM";
export var banner_content = "index-module--banner_content--m7Lno";
export var banner_link = "index-module--banner_link--CbRY5";
export var computeNestFeatures = "index-module--computeNestFeatures--x9y0w";
export var computeNestFeatures_body = "index-module--computeNestFeatures_body--zRDth";
export var introduction = "index-module--introduction--+YJx6";
export var introduction_body = "index-module--introduction_body--r7SjT";
export var introduction_body_end = "index-module--introduction_body_end--XdQ5s";
export var introduction_header = "index-module--introduction_header--LLzkf";
export var summary = "index-module--summary--wukqV";